import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiAward, FiBook } from 'react-icons/fi';
import Section from './Section';

const EDUCATION = [
  {
    school: 'University of Michigan',
    location: 'Ann Arbor, MI',
    degree: 'B.S. in Computer Science',
    minor: 'Minor in Mathematics',
    dates: '',
    coursework: [
      'EECS 281: Data Structures and Algorithms',
      'EECS 370: Computer Organization',
      'EECS 280: Programming and Algorithms',
      'EECS 203: Discrete Mathematics',
      'EECS 485: Web Systems',
      'EECS 484: Database Management Systems',
    ],
  },
  {
    school: 'Northville High School',
    location: 'Northville, MI',
    degree: 'High School Diploma',
    dates: '',
    awards: ['National Merit Nvidia Scholar', 'Northville Robotics World Qualifier '],
    coursework: ['AP CS A', 'AP Calculus BC', 'AP Physics C'],
  },


];

const Education = () => {
  return (
    <Section id="education" className="section-dark">
      <Container>
        <h2 className="section-title text-center">Education</h2>

        <div className="edu-timeline">
        {EDUCATION.map((item, index) => (
          <div key={item.school} className={`edu-item ${index > 0 ? 'mt-4 pt-4' : ''}`}>
          <Row className="align-items-start gy-3">
            <Col md={4}>
              <div className="edu-heading">
                <div className="h5 mb-1">{item.school}</div>
                <div className="edu-meta small">{item.location}</div>
                <div className="edu-meta small">{item.dates}</div>
              </div>
            </Col>
            <Col md={8}>
              <div className="edu-card rounded-3">
                <div className="card-index top-left">
                  <span>{index + 1}</span>
                  <span className="suit">♥</span>
                </div>
                <div className="card-index bottom-right">
                  <span>{index + 1}</span>
                  <span className="suit">♥</span>
                </div>
                <div className="card-watermark">♥</div>

                <div className="edu-card-content">
                <div className="fw-semibold mb-1" style={{ color: '#121519' }}>
                  {item.degree}
                  {item.minor ? ` — ${item.minor}` : ''}
                </div>
                {item.gpa && (
                  <div className="text-muted small mb-2" style={{ color: '#3b3f45' }}>GPA: {item.gpa}</div>
                )}

                {item.awards && item.awards.length > 0 && (
                  <div className="mb-2 d-flex align-items-start gap-2">
                    <FiAward style={{ color: 'var(--accent-red)' }} className="flex-shrink-0" />
                    <div className="small">{item.awards.join(' • ')}</div>
                  </div>
                )}

                {item.coursework && item.coursework.length > 0 && (
                  <div className="mt-2 d-flex align-items-start gap-2 flex-wrap">
                    <div className="d-flex align-items-center gap-2 w-100">
                      <FiBook style={{ color: '#1f6feb' }} className="flex-shrink-0" />
                      <div className="small text-muted">Selected coursework</div>
                    </div>
                    <div className="w-100 mt-1 d-flex gap-2 flex-wrap">
                      {item.coursework.map((c) => (
                        <span key={c} className="badge rounded-pill bg-secondary-subtle text-light border border-secondary-subtle course-badge">
                          {c}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                </div>
              </div>
            </Col>
          </Row>
          </div>
        ))}
        </div>
      </Container>
    </Section>
  );
};

export default Education;
